import { Component, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { NewsFeedItemHeaderChecklistComponent } from './news-feed-item-header-checklist/news-feed-item-header-checklist.component';
import { NewsFeedModel } from '../news-feed.model';
import { NewsFeedItemHeaderBase_newsItem, NewsFeedItemHeaderBase_showForumData } from './news-feed-item-header-base';
import { NewsFeedItemHeaderPostComponent } from './news-feed-item-header-post/news-feed-item-header-post.component';
import { NewsFeedItemHeaderDocumentComponent } from './news-feed-item-header-document/news-feed-item-header-document.component';
import { NewsFeedItemHeaderMediaBankComponent } from './news-feed-item-header-media-bank/news-feed-item-header-media-bank.component';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { NewsFeedItemHeaderFormComponent } from '@fi-app/news-feed/news-feed-item-header/news-feed-item-header-form/news-feed-item-header-form.component';
import { NewsFeedItemHeaderFormReminderComponent } from '@fi-app/news-feed/news-feed-item-header/news-feed-item-header-form-reminder/news-feed-item-header-form-reminder.component';
import { NewsFeedItemHeaderTaskReminderComponent } from '@fi-app/news-feed/news-feed-item-header/news-feed-item-header-task-reminder/news-feed-item-header-task-reminder.component';
import { NewsFeedItemHeaderPkComponent } from '@fi-app/news-feed/news-feed-item-header/news-feed-item-header-pk/news-feed-item-header-pk.component';
import { NewsFeedItemHeaderBalooComponent } from '@fi-app/news-feed/news-feed-item-header/news-feed-item-header-baloo/news-feed-item-header-baloo.component';

@Component({
    selector: 'fi-news-feed-item-header',
    template: '<ng-container *ngComponentOutlet="getComponentType()"></ng-container>',
    styleUrls: ['./news-feed-item-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-news-feed-item-header' },
    providers: [
        {
            provide: NewsFeedItemHeaderBase_newsItem,
            useFactory: (instance: NewsFeedItemHeaderComponent) => instance.newsItem,
            deps: [NewsFeedItemHeaderComponent],
        },
        {
            provide: NewsFeedItemHeaderBase_showForumData,
            useFactory: (instance: NewsFeedItemHeaderComponent) => instance.showForumData,
            deps: [NewsFeedItemHeaderComponent],
        },
    ],
    standalone: false,
})
export class NewsFeedItemHeaderComponent {
    @Input() newsItem: NewsFeedModel;
    @Input() showForumData: boolean;

    getComponentType() {
        if (this.newsItem.ObjectType === ObjectTypes.Post || this.newsItem.ObjectType === ObjectTypes.ForumPost)
            return NewsFeedItemHeaderPostComponent;

        if (this.newsItem.ObjectType === ObjectTypes.Document) return NewsFeedItemHeaderDocumentComponent;

        if (this.newsItem.ObjectType === ObjectTypes.MediaBank) return NewsFeedItemHeaderMediaBankComponent;

        if (this.newsItem.ObjectType === ObjectTypes.CheckList) return NewsFeedItemHeaderChecklistComponent;

        if (this.newsItem.ObjectType === ObjectTypes.MediaBankGrouped) return NewsFeedItemHeaderMediaBankComponent;

        if (this.newsItem.ObjectType === ObjectTypes.Form) return NewsFeedItemHeaderFormComponent;

        if (this.newsItem.ObjectType === ObjectTypes.FormReminder) return NewsFeedItemHeaderFormReminderComponent;

        if (this.newsItem.ObjectType === ObjectTypes.TaskReminder) return NewsFeedItemHeaderTaskReminderComponent;

        if (this.newsItem.ObjectType === ObjectTypes.PKImportLog) return NewsFeedItemHeaderPkComponent;

        if (this.newsItem.ObjectType === ObjectTypes.BalooSyncLog) return NewsFeedItemHeaderBalooComponent;

        throw new Error('Wrong item object type ' + this.newsItem.ObjectType);
    }
}
